import { memo } from 'react';
import classes from 'classnames';
import CheckIcon from 'assets/icons/check.svg?react';
import CheckDisabledIcon from 'assets/icons/check-disabled.svg?react';
import styles from './Progress.module.scss';

export type Props = {
  steps: Array<string>;
  currentStep: number;
  className?: string;
  dataTest?: string;
  disabled?: boolean;
  nextStepsDisabled?: boolean;
};

function Progress({
  steps = [],
  currentStep = 0,
  className,
  dataTest = 'progress',
  disabled = false,
  nextStepsDisabled = false,
}: Props) {
  return (
    <div data-test={dataTest} className={className}>
      {steps.map((step, index) => {
        const isCompletedStep = currentStep > index;
        const isCurrentStep = currentStep === index;

        const enabled =
          (isCompletedStep || (isCurrentStep && !nextStepsDisabled)) &&
          !disabled;

        return (
          <div
            className={classes(
              styles.section,
              index !== 0 && styles.line,
              enabled && styles.active,
            )}
            key={step}
            data-test={`${dataTest}`}
          >
            <div className={styles.step}>
              <div
                data-test={`circle-${index}-step-${index}`}
                className={classes(styles.circle, enabled && styles.active)}
              >
                {isCompletedStep &&
                  (disabled ? (
                    <CheckDisabledIcon
                      data-test={`circle-${index}-check-disabled-icon-${index}`}
                    />
                  ) : (
                    <CheckIcon
                      data-test={`circle-${index}-check-icon-${index}`}
                    />
                  ))}
              </div>
              <span
                data-test={`label-${index}`}
                className={classes(styles.label, enabled && styles.active)}
              >
                {step}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const ProgressMemo = memo(Progress);

export default ProgressMemo;
